import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
import './CoderCount.scss';

export interface CoderCountProps {
  count: number;
  className?: string;
}

export const CoderCount: React.FC<CoderCountProps> = ({
  count,
  className = ''
}) => {
  const label = count === 1 ? '1 Coder Assigned' : `${count} Coders Assigned`;

  return (
    <Flex
      alignItems="center"
      gap="2"
      className={`cmx-coder-count ${className}`.trim()}
      data-testid="coder-count"
    >
      <BiomeIcon iconName={IconName.User} titleText="Coders" />
      <Text className="cmx-coder-count__label" data-testid="coder-count-label">
        {label}
      </Text>
    </Flex>
  );
};

CoderCount.displayName = 'CoderCount';
export default CoderCount;
